import React, { useMemo, useState } from "react";
import * as S from "./SurveyList.style";
import { useTranslation } from "react-i18next";
import ZaiaInput from "../../../../../../zaiaComponents/zaiaInput";
import * as P from "../../../../../../../utils/pipes";
import { v4 as uuidv4 } from 'uuid';
import ZaiaReaction from "../../../../../../zaiaComponents/zaiaReaction";
import FlorenzButton from "../../../../../../florenzComponents/florenzButton";

const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;

function SurveyList({
  selectedSurvey,
  selectedProcess,
  changeFormField,
  surveyList,
  goNextInput,
  setPreviewSurveyView,
  inputSearchText
}) {

  const {t, i18n: { language }} = useTranslation("global");


  const getFilterText = (text) => {
    return inputSearchText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputSearchText).toLowerCase())
      : true
  }

  const handleSelectSurvey = (survey) => {
    if(survey.id !== selectedSurvey.value && survey.text !== selectedSurvey.text) {
      changeFormField(
        [
          {   
            value: survey.id,
            text: survey.text,
            fieldName: "survey"
          }
        ]
      )
      goNextInput()
    }
  }

  const getSurveyList = () => {

    return (
      <>
        <div className={`list__results ${inputSearchText === "" && "list__results--hidden"}`}>{t("globally.resultsFor")} "{inputSearchText}"</div>
        <div className="list__container">
          {
            surveyList?.map((survey) => {
              if(getFilterText(survey.text)) {
                return (
                  <S.ItemSurveys
                    key={uuidv4()}
                    selected={survey.id === selectedSurvey.value && survey.text === selectedSurvey.text}
                  >
                    <div 
                      className={`item`}
                      key={uuidv4()}
                      >
                      <div className="item__left"
                          onClick={() => handleSelectSurvey(survey)}
                      >
                        <div className="item__radio-button">
                          <div className="item__radio-button-content"></div>
                        </div>
                        <div className="item__text">
                          <div className="item__title"
                          >
                            {survey.text}
                          </div>
                          <div className="item__subtitle">
                            {survey.questionsNumber} {t("surveys.questions")}
                          </div>
                        </div>
                      </div>
                      <div className="item__right">
                        <div className="preview-button">
                          <FlorenzButton
                            typeStyle={"outline"}
                            size="s"
                            text={t("surveys.preview")}
                            widthComplete={true}
                            onClick={() => setPreviewSurveyView(survey.id)}
                          />
                        </div>
                      </div>
                    </div>
                  </S.ItemSurveys>
                )
              } else {
                return null
              }
            })
          }
        </div>
      </>
    )

  }

  return (
    <S.SurveyList
      searcher={inputSearchText}
    >
      <div className="list">
        {
          getSurveyList()
        }
      </div>
      
    </S.SurveyList>
  );
}

export default SurveyList;
